module.exports = "./img/desktop_logo.dfc7981.png";